import React, { useState } from 'react';
import TripQuestionnaireForm from './TripQuestionnaireForm';
import {
  Box,
  Container,
  Typography,
  Button,
  Dialog,
  Paper,
  DialogContent,
  styled
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { LeadFormData } from '../../types/leads';
import * as triplinkService from '../../utils/triplinkService'

interface TripQuestionnaireProps {
  preferredLink: string;
  onBack: () => void
}

const SuccessIcon = styled(CheckCircleIcon)`
  font-size: 64px;
  color: ${props => props.theme.palette.success.main};
`;

const DetailText = styled(Typography)`
  color: ${props => props.theme.palette.text.secondary};
`;

const ConfirmationCard = styled(Paper)`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

export default function TripQuestionnaire({ preferredLink, onBack }: TripQuestionnaireProps) {
  const [showEnquiryInfoConfirm, setShowEnquiryInfoConfirm] = useState(false)

  const handleSubmit = (data: LeadFormData) => {
    const { name, email, phoneNumber, ...tripDetails } = data

    const formattedData = {
      name: name,
      email: email,
      phone: phoneNumber,
      trip_details: tripDetails
    }

    triplinkService.createNewLead(preferredLink, formattedData)

    // Pop up the confirmation modal
    setShowEnquiryInfoConfirm(true);
  };

  const handleReturnHome = () => {
    onBack()
  }

  return (
    <Container maxWidth="lg">
      <Box py={4}>
        <TripQuestionnaireForm onSubmit={handleSubmit} />
      </Box>
      <Dialog open={showEnquiryInfoConfirm} fullScreen>
        <DialogContent
          style={{
            maxWidth: '600px',
            display: 'flex',
            alignSelf: 'center',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ConfirmationCard>
            <SuccessIcon />
            <Typography variant="h4">Enquiry Information Sent!</Typography>
            {/* <Box>
              <DetailText variant="body1">
                Your meeting with {expertName} has been scheduled for:
              </DetailText>
              <Typography variant="h6" sx={{ mt: 1 }}>
                {formattedDateTime}
              </Typography>
            </Box> */}
            <DetailText>
              Following an enquiry your Expert will typically do some research then get in contact (phone, email or face to face.)
            </DetailText>
            <DetailText>
              Response times will vary based on Trip requirements, complexity, existing workload, location etc.
            </DetailText>
            <Button
              variant="contained"
              color="primary"
              onClick={handleReturnHome}
              sx={{ mt: 2 }}
            >
              Return to Home
            </Button>
          </ConfirmationCard>
        </DialogContent>
      </Dialog>
    </Container>
  );
}
